/* eslint-disable @reatom/unit-naming-rule */
import { action, atom, onConnect } from '@reatom/framework'

import { AsyncStateN, pipe, Result } from '@blade/std-lib'
import { Network, selectedNetworkAtom } from '@root/entities/network'
import { pairRegistry } from '@root/entities/pair/atoms'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'
import { reatomRequest } from '@root/shared/lib'

export const fetchUserRecentPairsRequestAction = action(
  async (ctx, { network }: { network: Network.Network }) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userRecentPairsList, [
        {
          network: Network.toDto(network),
        },
      ]),
    )

    const mappedResult = pipe(
      result,
      Result.mapError(ApiError.fallbackToUnknown),
    )

    return mappedResult
  },
  'fetchUserRecentPairsRequestAction',
)

const reatomRecentTradingPairs = (network: Network.Network) => {
  const fetchRecentPairsAction = action(async (ctx) => {
    const result = await ctx.schedule(() =>
      fetchUserRecentPairsRequestAction(ctx, { network }),
    )

    return result.pipe(
      Result.map((it) =>
        it.map((dto) => pairRegistry.resolveFromDto(ctx, dto)),
      ),
    )
  })

  const pairsAtom = reatomRequest({
    execAction: fetchRecentPairsAction,
    name: `${network}_recentPairs`,
  })

  onConnect(pairsAtom, (ctx) => {
    const state = ctx.get(pairsAtom)
    if (AsyncStateN.isSuccess(state)) {
      return
    }
    pairsAtom.execute(ctx)
  })

  return pairsAtom
}

const recentPairsByNetwork = Network.byNetworkRecord((network) =>
  reatomRecentTradingPairs(network),
)

export const recentPairsModelAtom = atom((ctx) => {
  const network = ctx.spy(selectedNetworkAtom)
  return recentPairsByNetwork[network]
}, 'recentPairsModelAtom')
